import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Grid, Paper, Typography } from '@mui/material';
import { AddCircle as AddCircleIcon } from '@mui/icons-material';
const Root = styled(Paper)(({ theme, fill, small }) => (Object.assign(Object.assign({ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', minHeight: 142, borderWidth: 1, borderStyle: 'dashed', borderColor: theme.palette.primary.light, transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms', cursor: 'pointer', '&:hover': {
        backgroundColor: theme.palette.primary.light,
        borderColor: theme.palette.primary.main,
    } }, (fill
    ? {
        height: '100%',
    }
    : {})), (small
    ? {
        minHeight: 60,
        flexDirection: 'row',
        '& > .label': {
            marginTop: 0,
            marginLeft: theme.spacing(1),
        },
    }
    : {}))));
const Icon = styled('div')(({ theme }) => ({
    color: theme.palette.primary.main,
    width: theme.spacing(4),
    height: theme.spacing(4),
    '& > svg': {
        width: 'inherit',
        height: 'inherit',
    },
}));
const Label = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.primary,
    marginTop: theme.spacing(2),
}));
const GridActionCard = ({ label, icon, gridSize = 3, fill = false, small = false, onClick }) => {
    return (_jsx(Grid, Object.assign({ item: true, xs: gridSize, zeroMinWidth: true }, { children: _jsxs(Root, Object.assign({ fill: +!!fill, small: +!!small, onClick: onClick }, { children: [_jsx(Icon, { children: icon ? icon : _jsx(AddCircleIcon, {}) }), label && _jsx(Label, Object.assign({ className: "label" }, { children: label }))] })) })));
};
export default GridActionCard;
//# sourceMappingURL=index.js.map